// Phosphor field design tokens — CRT texture, dual spectrum (green / amber)

export const COLORS = {
  phosphor: {
    green: '#c6e89a',
    greenDim: '#8fb86a',
    greenMute: '#5d7a48',
    amber: '#e8c36a',
    amberDim: '#c49a3e',
    amberMute: '#8a6c2c',
    bloom: 'rgba(198, 232, 154, 0.35)',
    amberBloom: 'rgba(232, 195, 106, 0.35)',
  },

  primary: {
    50: '#eef6e4',
    100: '#d4e8b8',
    200: '#c6e89a',
    300: '#a8d06e',
    400: '#8fb86a',
    500: '#c6e89a',
    600: '#8fb86a',
    700: '#5d7a48',
    800: '#3d522f',
    900: '#24321c',
  },

  neutral: {
    50: '#e8efe0',
    100: '#c5d0b8',
    200: '#8a9a7a',
    300: '#6b7a5c',
    400: '#5d7a48',
    500: '#4a5c3c',
    600: '#354228',
    700: '#24301c',
    800: '#1a2214',
    900: '#0e140b',
  },

  success: {
    50: '#eef6e4',
    500: '#8fb86a',
    600: '#5d7a48',
    700: '#3d522f',
  },

  warning: {
    50: '#f6edd4',
    500: '#e8c36a',
    600: '#c49a3e',
    700: '#8a6c2c',
  },

  error: {
    50: '#f6e4e0',
    200: '#c97a6a',
    500: '#e08a7a',
    600: '#c45a4a',
    700: '#8a3a30',
  },

  background: {
    primary: '#10160e',
    secondary: '#161d12',
    transparent: 'transparent',
    tertiary: '#1c2418',
    dark: '#0b1009',
    darkSecondary: '#161d12',
  },

  text: {
    primary: '#d7e8c4',
    secondary: '#9aaf82',
    tertiary: '#6b7a5c',
    inverse: '#10160e',
    muted: '#5d7a48',
  },
};

export const TYPOGRAPHY = {
  fontFamily: {
    sans: [
      '"IBM Plex Mono"',
      'ui-monospace',
      'SFMono-Regular',
      'Menlo',
      'Monaco',
      'Consolas',
      'monospace',
    ],
    mono: [
      '"IBM Plex Mono"',
      'ui-monospace',
      'SFMono-Regular',
      'Menlo',
      'Monaco',
      'Consolas',
      'monospace',
    ],
    display: ['"Share Tech Mono"', '"IBM Plex Mono"', 'ui-monospace', 'monospace'],
  },

  fontSize: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem',
  },

  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },

  lineHeight: {
    tight: 1.25,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2,
  },
};

export const SPACING = {
  0: '0',
  1: '0.25rem',
  2: '0.5rem',
  3: '0.75rem',
  4: '1rem',
  5: '1.25rem',
  6: '1.5rem',
  8: '2rem',
  10: '2.5rem',
  12: '3rem',
  16: '4rem',
  20: '5rem',
  24: '6rem',
  32: '8rem',
  40: '10rem',
  48: '12rem',
  56: '14rem',
  64: '16rem',
};

export const BREAKPOINTS = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};

export const SHADOWS = {
  sm: '0 0 8px rgba(198, 232, 154, 0.08)',
  base: '0 0 12px rgba(198, 232, 154, 0.12)',
  md: '0 0 18px rgba(198, 232, 154, 0.16)',
  lg: '0 0 28px rgba(198, 232, 154, 0.2)',
  xl: '0 0 40px rgba(198, 232, 154, 0.24)',
  '2xl': '0 0 56px rgba(198, 232, 154, 0.28)',
  inner: 'inset 0 0 12px rgba(0, 0, 0, 0.35)',
};

export const BORDER_RADIUS = {
  none: '0',
  sm: '0.125rem',
  base: '0.125rem',
  md: '0.25rem',
  lg: '0.25rem',
  xl: '0.25rem',
  '2xl': '0.25rem',
  '3xl': '0.25rem',
  full: '9999px',
};

export const Z_INDEX = {
  hide: -1,
  auto: 'auto',
  base: 0,
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  overlay: 1040,
  modal: 1050,
  popover: 1060,
  tooltip: 1070,
  toast: 1080,
};

export const ANIMATION = {
  duration: {
    fast: '150ms',
    base: '200ms',
    slow: '300ms',
    slower: '500ms',
  },

  easing: {
    linear: 'linear',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
};
